import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Configuration, getDescription } from 'src/app/enum/Configuration';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NetworkOutageService } from 'src/app/services/network-outage.service';
import { NotificationService } from 'src/app/services/notification-service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-network-outage',
  templateUrl: './network-outage.component.html',
  styleUrls: ['./network-outage.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class NetworkOutageComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  data :any = []
  dataSource = new MatTableDataSource(this.data)
  displayedColumns: any = [
    'serviceprovider',
    'province',
    'city',
    'subject',
    'createduser',
    'createddate',
    'OutageStatus',
    'action'
  ]
  filterSearchForm: FormGroup
  filterOpen: boolean = false
  serviceProviderList
  filteredList1
  filteredList3
  provinceList: any = []
  serviceprovider: Configuration
  constructor(
    public navigation: NavigationService,
    public NetworkOutageService: NetworkOutageService,
    public formBuilder: FormBuilder,
    public lookupdataservice: LookupDataServiceService,
    public toast: NotificationService,
  ) { }

  ngOnInit(): void {
    this.filterSearchForm = this.formBuilder.group({
      startDate: [],
      endDate: [],
      serviceProviderId: [],
      provinces: []
    })
    this.lookupdataservice.getServiceProvider().subscribe((result) => {
      this.serviceProviderList = result
      this.filteredList1 = [...this.serviceProviderList]
    })
    this.lookupdataservice.getProvince().subscribe((result) => {
      this.provinceList = result
      this.filteredList3 = [...this.provinceList]
    })
    this.getdata()
  }

  getdata() {
//null need to handle
    this.NetworkOutageService.GetNetworkOutageList().subscribe((result) => {
      this.data = result


      this.data = this.data.map(item => ({ ...item, serviceProviderId: getDescription(item.serviceProviderId) }))
      console.log(this.data);

      this.dataSource = new MatTableDataSource(this.data)
      this.dataSource.paginator = this.paginator
    })
  }
  gotoaddoutage(id) {
    this.navigation.goToaddnetworkoutage(id);
  }

  advancedSearchClick() {
    let value = this.filterSearchForm.value
    if (value.startDate && !value.endDate || !value.startDate && value.endDate)
      this.toast.showError('Start Date and End date both need to be fill')
    debugger
    
    if (!this.isFormEmpty()) {
      this.NetworkOutageService.GetNetworkOutageBySearchQuery(value).subscribe((result) => {
        if (result != "No matching outages found.") {
          this.data = result
          this.data = this.data.map(item => ({ ...item, serviceProviderId: getDescription(item.serviceProviderId) }))
          this.dataSource = new MatTableDataSource(this.data)
          this.dataSource.paginator = this.paginator
        }
        else {
          this.data = null
          this.dataSource.data = []
          this.dataSource.paginator = this.paginator
          this.toast.showError('No matching outages found.')
        }
      })
    }
  }

  isFormEmpty(): boolean {
    return Object.values(this.filterSearchForm.value).every(value => value === null || value === '');
  }
  

  clearFilter() {
    this.filterSearchForm.reset()
    this.getdata()
  }

  delete(id, flag?) {
    const txt = 'Are you sure you want to Delete this?';
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.NetworkOutageService.DeleteNetworkOutageById(id).subscribe((reuslt) => {
          if (reuslt)
            this.clearFilter()
        })
      }
    });

  }
  close(id, flag) {
    let txt = ""
    if (flag)
      txt = 'Are you sure you want to Open this?';
    else
      txt = 'Are you sure you want to Close this?';

    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.NetworkOutageService.ModifyNetworkOutageStatusById(id).subscribe((reuslt) => {
          if (reuslt)
            this.clearFilter()
        })
      }
    });
  }
}

